import { Flex } from "@chakra-ui/react";

export default function Container({ bg, hoverBg, ...rest }) {
  return (
    <Flex
      bg={bg}
      _hover={{
        bg: hoverBg
      }}
      borderRadius={["14px", null, "18px"]}
      alignItems="center"
      mr="8px"
      sx={{
        ":last-of-type": {
          mr: "0px"
        }
      }}
      {...rest}
    />
  );
}
